<template>
	<div class="row mx-0" style="padding-left: 1.5rem; position: relative;">

		<!-- delete item button -->
		<button :disabled="disabled || !source" class="btn btn-danger mt-1" @click.prevent="deleteThisItem" style="width: 40px; position: absolute; right: -50px; top: 0;"><i class="fas fa-times"></i></button><!-- TODO -->

		<!-- object field name entry (object only) -->
		<div class="col p-0 text-nowrap pr-2" style="min-width: 140px; margin-left: -1.5rem !important;">
			<input :disabled="disabled" type="text" class="form-control mt-1" v-model="field.name" placeholder="[Field Name]" style="display: inline !important;">
			<label class="col-form-label font-weight-bold mt-1" style="display: inline !important;">:</label>
		</div>

		<!-- value type selector -->
		<div class="col-2 pl-1 pr-0" style="min-width: 130px; width: 100%;">
			<select :disabled="disabled" class="form-control mt-1" v-model="field.valuetype">
				<option :value="undefined">- Any Type -</option>
				<option value="string">Text String</option>
				<option value="number">Number</option>
				<option value="date">Date</option>
				<option value="boolean">Boolean (On/Off)</option>
				<option value="reference">Reference</option>
				<!-- <optgroup label="Binary (File)">
					<option value="image">Image</option>
					<option value="file_any">Any File</option>
				</optgroup> -->
				<option value="array">List (Array)</option>
				<option value="object">Object</option>
			</select>
		</div>

		<!-- value entry controls -->
		<div class="col-auto pl-1 pr-0">
			<input-checkbox :disabled="disabled" class="d-inline-block mt-1" v-model="field.required" label="Required" />
			<input-checkbox :disabled="disabled" class="d-inline-block mt-1" v-model="field.allownull" label="Null" />
		</div>

		<div class="col-auto pl-1 pr-0">
			<!-- The show-validators toggle stays active -->
			<button :class="{'d-none':showValidators}" @click.prevent="toggleValidators();" class="btn btn-light mt-1"><i class="fas fa-caret-down"></i> Validators ({{validators.length}})</button>
			<button :class="{'d-none':!showValidators}" @click.prevent="toggleValidators();" class="btn btn-secondary mt-1"><i class="fas fa-caret-up"></i> Validators ({{validators.length}})</button>
			<button @click.prevent="toggleMixins()" class="btn mt-1 mr-1" :class="{ 'btn-secondary': showMixins, 'btn-light': !showMixins }"><i class="fas fa-vials"></i></button>
		</div>

		<template v-if="showValidators">
			<div class="col-auto pl-0 pr-0" :class="{'mb-2':validators.length < 1}">
				<button v-if="!disabled" @click.prevent="addValidator" class="btn btn-info mt-1 mr-1"><i class="fas fa-plus"></i> Add Validator</button>
			</div>
			<div v-if="validators.length > 0" class="col-12 pl-1 pr-0">
				<schema-field-validator :disabled="disabled" v-for="(v,index) in validators" :item="v" :key="index" :index="index" :source="field.validators" :schemas="schemas" />
			</div>
		</template>
		<div v-else-if="showMixins" class="border col-12 mb-2" :id="'editor-mixins-'+_uid"></div>
		
		<div v-if="( [ 'object', 'array' ].includes( field.valuetype ) || !field.valuetype ) && addFieldFunction">
			<button v-if="field.$id" @click.prevent="addSubField" class="block btn btn-info mt-1">Add Sub Field</button>
			<button v-else disabled class="block btn btn-secondary mt-1">Add Sub Field <small>(Save Parent First)</small></button>
		</div>
		<div ref="schemaSubFields">
			<schema-editor-field v-for="( sf, sfIndex ) in subfields" :key="`sf_${field.$id}_${sfIndex}`" :field="sf" :source="subfields" :index="sfIndex" :schemas="schemas" :add-field-function="addFieldFunction" />
		</div>
	</div>
</template>

<script>
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import Vue from 'vue';
import SchemaFieldValidator from "@/components/utilities/SchemaFieldValidator";
import InputCheckbox from "@/components/utilities/InputCheckbox";
import SchemaEditorField from "@/components/utilities/SchemaEditorField";
import _ from 'lodash';

export default {
	name: "schema-editor-field",
	props: {
		field : { type : Object, required : true },	// The field to be rendered.
		index : { type : Number, required : false },	// Internal index of this time (for lists, it's used for numbering)
		source : { type : Array, required : true },	// Where does this field come from? So that that it can initiate its own deletion.
		disabled : { type : Boolean },	// Disable all form elements RECURSIVELY.
		schemas : { type : Object, required : true },	// List of this project's schemas for object validators.
		addFieldFunction : { type : Function, required : false },
	},
	components: {
		SchemaFieldValidator,
		InputCheckbox,
		SchemaEditorField,
	},
	data() {
		return {
			_fieldIdIndex : null,
			showValidators : false,
			showMixins : false,
			editorMixins : false
		};
	},
	watch: {
		"field.required" : function( newVal, oldVal )
		{
			if( newVal === false )
				this.$delete( this.field, 'required' );
		},
		"field.allownull" : function( newVal, oldVal )
		{
			if( newVal === false )
				this.$delete( this.field, 'allownull' );
		}
	},
	mounted( )
	{
		console.log( "BASE FIELD $id", this.field.$id );
	},
	computed: {
		validators( )
		{
			return this.field.validators || [];
		},
		subfields( )
		{
			const sfs = Array.isArray( this.field.subfields ) ? this.field.subfields : [];
			return sfs.filter( sf => !sf._delete );
		}
	},
	methods:
	{
		addSubField( )
		{
			this.addFieldFunction( this.field.$id, this.$refs.schemaSubFields );
		},
		toggleValidators( )
		{
			const show = !this.showValidators;

			if( show && this.showMixins )
			{
				this.toggleMixins( );
				this.$nextTick( ( () => {
					this.showValidators = show;
				} ).bind(this) );
			}
			else
				this.showValidators = show;
		},
		toggleMixins( state )
		{
			const show = ( typeof state === 'boolean' ? state : !this.showMixins );
			
			if( !show )
			{
				this.editorMixins.destroy( );
				this.editorMixins = null;
			}

			this.showMixins = !!show;
			
			if( show )
			{
				this.showValidators = false;
				this.$nextTick( ( () => {
					this.editorMixins = ace.edit( "editor-mixins-"+ this._uid, {
						mode: "ace/mode/json",
						theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
						maxLines: 20,
						minLines: 5,
						fontSize: 14,
						showPrintMargin : false,
						
					});
					const mixins = _.cloneDeep( this.field.$mixins || { } );
					for( let mf in mixins )	// Remove all $new fields.
						try {
							delete mixins[mf].$new;
						} catch( err ) { }
					this.editorMixins.setValue( JSON.stringify( mixins || { }, null, 2 ), -1 );
					this.editorMixins.getSession().on( 'change', (e) => {
						try {
							const mixins = JSON.parse( this.editorMixins.getValue( ) );
							for( let mf in mixins )	// Re-add all the $new fields.
								try {
									if( !mixins[mf].$delete && this.field.$id )
										mixins[mf].$new = true;
								} catch( err ) { }
							this.$set( this.field, '$mixins', mixins );
						} catch( err ) { /* Oh well.. */ }
					});
				} ).bind(this) );
			}
		},
		addValidator( )
		{
			if( !Array.isArray( this.field.validators ) )
				this.$set( this.field, 'validators', [] );
			this.$set( this.field.validators, this.field.validators.length, { $schema : "$validatorinclude.", validator : '$string', config : { } } );
		},
		getDateLocalISOString( value )
		{
			try {
				let month = value.getMonth( ) + 1;
				if( month < 10 ) month = "0"+ month;
				let day = value.getDate( );
				if( day < 10 ) day = "0"+ day;
				let hours = value.getHours( );
				if( hours < 10 ) hours = "0"+ hours;
				let minutes = value.getMinutes( );
				if( minutes < 10 ) minutes = "0"+ minutes;
				let seconds = value.getSeconds( );
				if( seconds < 10 ) seconds = "0"+ seconds;
				return value.getFullYear() +"-"+ month +"-"+ day +"T"+ hours +":"+ minutes +":"+ seconds;
			} catch( err ) { return ""; }
		},
		getNewFieldIdIndex( )
		{
			this._fieldIdIndex = ""+ Math.random( );
			return this._fieldIdIndex;
		},
		getValueTypeClass( valueType )
		{
			switch( valueType )
			{
				case 'array':
				case 'object':
				case 'reference':
				case 'string.block':
				case 'string.html':
					return 'col-12';
			}
			return "col";
		},
		deleteThisItem( )
		{
			const validators = this.field.validators;
			if( Array.isArray( validators ) && validators.length > 0 )
			{
				if( !confirm( `All ${validators.length} validators will be deleted as well. Continue?` ) )
					return;
			}
			if( this.field.$id )
			{
				if( !confirm( `This is an existing field that might be overridden or relied on by derived schemas. Are you sure you want to mark it for deletion?`
					+`\nOnce the schema changes are saved, the deletion will be final. Even if you re-create another field with the same name, any derived schemas' overrides will still be cleared.` ) )
					return;
				this.$set( this.field, '_delete', true );
			}
			else
			{
				// WIP (Check if this.source is root, or else find another way to get parent field...)

				// const field = this.source[this.index];
				// if( field && field.parent )
				// {
				// 	console.log( "Deleting EMPTY Subfield", this.index, field );
				// 	const parentField = this.source.find( f => f.$id === field.parent );
				// 	if( parentField && Array.isArray( parentField.subfields ) )
				// 	{
				// 		const deleteIndex = parentField.subfields.findIndex( sf => _.isEqual( sf, field ) )
				// 		console.log( "Delete Index:", deleteIndex );
				// 		if( deleteIndex > -1 )
				// 			this.$delete( parentField.subfields, deleteIndex );
				// 	}
				// }

				this.$delete( this.source, this.index );
			}
		},
	}
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/SchemaEditorField.vue